// extracted by mini-css-extract-plugin
module.exports = {"priceDropContainer":"_1O7yj","priceDropContainerDesktopVariant":"_2XkCB","heading":"CP0vH","savingSticker":"_20VK2","price":"_2XIE3","subHeading":"AgmFB"};